import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Schema } from 'features/inventory/domain/forms/RichPlacementsForm/sections/MultiAnchorForm/schema'
import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'domainId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      adUnitIds,
      autoGenerateDivIdsEnabled,
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      matchType,
      path,
      pathTriggerEnabled,
      showCloseButton,
      singleAdViewTime,
    }: From): To => {
      const constantFields: Omit<To, 'adUnitIds' | 'autoGenerateDivIdsEnabled'> = {
        customizeApperanceEnabled: customizeAppearance,
        customizeBasicSettingsEnabled: customizeBasicSettings,
        customStyling: JSON.parse(customStyling),
        customVariableTriggerEnabled,
        ...(customVariableTriggerEnabled ? { customVariableName, customVariableValue } : {}),
        displayAfterUserInteractionEnabled: displayAfterUserInteraction,
        enabled,
        fullWidthModeEnabled: fullWidthMode,
        pathTriggerEnabled,
        ...(pathTriggerEnabled ? { matchType, path } : {}),
        showCloseButtonEnabled: showCloseButton,
        singleAdViewTime,
      }

      const variableFields: Pick<To, 'adUnitIds' | 'autoGenerateDivIdsEnabled'> = {
        adUnitIds: adUnitIds.right,
        autoGenerateDivIdsEnabled,
      }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<Variables>({
            adUnitIds: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-multiAnchorAdUnitConnection',
            ),
            autoGenerateDivIdsEnabled: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-multiAnchorAdUnitConnection',
            ),
          }),
        ),
      }
    },
  )
